import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-widget-message',
  templateUrl: './widget-message.component.html',
  styleUrls: ['./widget-message.component.scss']
})
export class WidgetMessageComponent implements OnInit {
  @Input() message:string
  constructor() { }

  ngOnInit(): void {
  }

}
